import { render } from "./MessageError.vue?vue&type=template&id=4b8c827a&ts=true"
import script from "./MessageError.vue?vue&type=script&lang=ts"
export * from "./MessageError.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__